import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const werkgeversVoordelen = [
  'Volledige RSZ/ONSS en Dimona-registratie door BVM verzorgd',
  'A1-certificaten en grensoverschrijdende belastingcompliance',
  'Inzet binnen 72 uur na aanvraag',
  'Kandidaatbriefings in Nederlands, Frans en Engels',
  'Sectorspecifieke certificeringen vooraf geverifieerd',
];

const kandidatenVoordelen = [
  'EU-burger — geen barrières, geen werkvergunning',
  'Belgische registratie en sociale zekerheid volledig geregeld',
  'Hulp bij huisvesting bij aankomst',
  '8 sectoren — vind uw match',
  'Begeleiding in uw eigen taal: PL, RO, CS, SK, HU, BG',
];

const VoorUBlok = () => {
  return (
    <section id="voor-u" className="relative overflow-hidden voor-u-gradient">
      <style>{`
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .voor-u-gradient {
          background: linear-gradient(135deg, #000000 0%, #001a0d 20%, #003320 40%, #00E5A0 60%, #001a0d 80%, #000000 100%);
          background-size: 400% 400%;
          animation: gradientShift 8s ease infinite;
        }
      `}</style>
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Werkgevers */}
        <motion.div
          className="py-20 md:py-28 px-8 lg:px-16 relative overflow-hidden"
          style={{ background: 'rgba(0,0,0,0.55)', borderRight: '1px solid rgba(0,229,160,0.15)', borderTop: '1px solid rgba(0,229,160,0.1)' }}
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="absolute top-0 left-0 w-64 h-64 rounded-full blur-[120px] opacity-10" style={{ background: '#00E5A0' }} />
          <div className="relative z-10">
            <p className="text-xs font-body font-medium tracking-[0.2em] uppercase mb-6" style={{ color: '#00E5A0' }}>
              VOOR WERKGEVERS
            </p>
            <h2 className="text-4xl md:text-5xl font-heading font-bold leading-tight text-white mb-6">
              EUROPEES<br />VAKPERSONEEL<br /><span style={{ color: '#00E5A0' }}>INZETTEN</span>
            </h2>
            <p className="text-base leading-relaxed mb-8" style={{ color: '#CCCCCC' }}>
              Toegang tot een voorgeselecteerde, compliance-geverifieerde pool van EU-professionals. Geen verborgen kosten, geen vergunningsproblemen — enkel gekwalificeerde mensen klaar voor dag één.
            </p>
            <ul className="space-y-4 mb-10">
              {werkgeversVoordelen?.map((item, i) => (
                <motion.li
                  key={i}
                  className="flex items-start gap-3"
                  initial={{ opacity: 0, x: -15 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 + i * 0.08 }}
                >
                  <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'rgba(0,229,160,0.2)', border: '1px solid rgba(0,229,160,0.4)' }}>
                    <Icon name="Check" size={11} color="#00E5A0" />
                  </div>
                  <span className="text-sm font-body" style={{ color: '#DDDDDD' }}>{item}</span>
                </motion.li>
              ))}
            </ul>
            <Link to="/login">
              <motion.button
                className="flex items-center gap-2 px-8 py-4 font-body font-semibold text-sm tracking-wide rounded-sm"
                style={{ background: '#00E5A0', color: '#0A0A0A' }}
                whileHover={{ scale: 1.04, background: '#00ffb3' }}
                whileTap={{ scale: 0.96 }}
              >
                PERSONEEL AANVRAGEN
                <Icon name="ArrowRight" size={18} color="#0A0A0A" />
              </motion.button>
            </Link>
          </div>
        </motion.div>

        {/* EU-Kandidaten */}
        <motion.div
          className="py-20 md:py-28 px-8 lg:px-16 relative overflow-hidden"
          style={{ background: 'rgba(0,0,0,0.45)', borderTop: '1px solid rgba(0,229,160,0.1)' }}
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="absolute bottom-0 right-0 w-64 h-64 rounded-full blur-[120px] opacity-10" style={{ background: '#00E5A0' }} />
          <div className="relative z-10">
            <p className="text-xs font-body font-medium tracking-[0.2em] uppercase mb-6" style={{ color: '#00E5A0' }}>
              VOOR EU-KANDIDATEN
            </p>
            <h2 className="text-4xl md:text-5xl font-heading font-bold leading-tight text-white mb-6">
              WERKEN<br />IN<br /><span style={{ color: '#00E5A0' }}>BeNeLux</span>
            </h2>
            <p className="text-base leading-relaxed mb-8" style={{ color: '#CCCCCC' }}>
              U bent EU-burger — geen werkvergunning vereist. BVM Group regelt huisvesting, officiële registratie en taalondersteuning zodat u zich kunt focussen op uw carrière.
            </p>
            <ul className="space-y-4 mb-10">
              {kandidatenVoordelen?.map((item, i) => (
                <motion.li
                  key={i}
                  className="flex items-start gap-3"
                  initial={{ opacity: 0, x: 15 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 + i * 0.08 }}
                >
                  <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'rgba(0,229,160,0.2)', border: '1px solid rgba(0,229,160,0.4)' }}>
                    <Icon name="Check" size={11} color="#00E5A0" />
                  </div>
                  <span className="text-sm font-body" style={{ color: '#DDDDDD' }}>{item}</span>
                </motion.li>
              ))}
            </ul>
            <Link to="/login">
              <motion.button
                className="flex items-center gap-2 px-8 py-4 font-body font-semibold text-sm tracking-wide rounded-sm border text-white"
                style={{ borderColor: 'rgba(0,229,160,0.4)', background: 'transparent' }}
                whileHover={{ borderColor: '#00E5A0', color: '#00E5A0' }}
                whileTap={{ scale: 0.96 }}
              >
                NU SOLLICITEREN
                <Icon name="ArrowRight" size={18} />
              </motion.button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VoorUBlok;
